module.exports = __webpack_public_path__ + "static/media/about_pc_4.cae48cfd.png";